import { useRecoilValue } from "recoil";
import { currentNewRequisition } from "../../recoil/atoms";
import { formatWithTimezoneOffset } from "../../utils/helpers";
import {
  getPatientSummaryPregnancyLabel,
  requiresEstimatedDueDate,
} from "./helpers";
import {
  NewReqPatientSummaryBannerWrapper,
  NewReqPatientSummaryColumn,
  SummaryLabel,
  SummaryValue,
} from "./NewRequisition.styles";

const EMPTY_VALUE = "—";

const NewReqPatientSummaryBanner = () => {
  const form = useRecoilValue(currentNewRequisition);
  const estimatedDueDate = requiresEstimatedDueDate(form)
    ? formatWithTimezoneOffset(form.estimatedDueDate)
    : "";

  return (
    <NewReqPatientSummaryBannerWrapper data-testid="new-test-patient-summary-banner">
      <NewReqPatientSummaryColumn>
        <SummaryLabel>Last name</SummaryLabel>
        <SummaryValue>{form.lastName?.trim() || EMPTY_VALUE}</SummaryValue>
        <SummaryLabel>First name</SummaryLabel>
        <SummaryValue>{form.firstName?.trim() || EMPTY_VALUE}</SummaryValue>
      </NewReqPatientSummaryColumn>
      <NewReqPatientSummaryColumn>
        <SummaryLabel>Date of Birth</SummaryLabel>
        <SummaryValue>
          {formatWithTimezoneOffset(form.dateOfBirth) || EMPTY_VALUE}
        </SummaryValue>
        <SummaryLabel>Estimated due date</SummaryLabel>
        <SummaryValue>{estimatedDueDate || EMPTY_VALUE}</SummaryValue>
      </NewReqPatientSummaryColumn>
      <NewReqPatientSummaryColumn>
        <SummaryLabel>Pregnancy</SummaryLabel>
        <SummaryValue>
          {getPatientSummaryPregnancyLabel(form) || EMPTY_VALUE}
        </SummaryValue>
      </NewReqPatientSummaryColumn>
    </NewReqPatientSummaryBannerWrapper>
  );
};

export default NewReqPatientSummaryBanner;
